import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const fleetColors = {
  success: tokens.status.success.fg,
  warning: tokens.accent.base,
  yellow: tokens.status.warning.fg,
  danger: tokens.status.danger.fg,
  info: tokens.status.info.fg,
  purple: tokens.status.info.fg,
  trackBg: tokens.surface.raised,
  cardSurface: tokens.surface.glass,
  cardInner: tokens.surface.inset,
  divider: tokens.border.hairline,
}

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
`

export const HeaderActions = styled.div`
  display: flex;
  gap: 1rem;
`

export const KpiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-bottom: 1rem;
`

export const DashGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 1rem;
  margin-bottom: 1rem;
`

export const CompositionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
  align-content: start;
`

export const CategoryTile = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  padding: 0.5rem 0.625rem;
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  box-shadow: inset 3px 0 0 0 ${tokens.accent.glowBorder};
  transition:
    border-color ${tokens.motion.duration} ${tokens.motion.ease},
    background ${tokens.motion.duration} ${tokens.motion.ease},
    box-shadow ${tokens.motion.duration} ${tokens.motion.ease};

  &:hover {
    border-color: ${tokens.accent.glowBorder};
    background: ${tokens.accent.soft};
    box-shadow: inset 3px 0 0 0 ${tokens.accent.base};
  }
`

export const TileIcon = styled.div`
  width: 1.625rem;
  height: 1.625rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${tokens.radius.chip};
  background: ${tokens.accent.soft};
  color: ${tokens.accent.onDark};

  svg {
    width: 0.875rem;
    height: 0.875rem;
    fill: currentColor;
  }
`

export const TileName = styled.span`
  flex: 1;
  min-width: 0;
  font-size: ${tokens.font.body};
  font-weight: 500;
  color: ${tokens.text.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const TileCount = styled.span`
  flex-shrink: 0;
  min-width: 1.5rem;
  padding: 0.25rem 0.5rem;
  border-radius: ${tokens.radius.chip};
  background: ${tokens.accent.soft};
  border: 1px solid ${tokens.accent.glowBorder};
  font-size: ${tokens.font.label};
  font-weight: 700;
  line-height: 1;
  text-align: center;
  color: ${tokens.accent.onDark};
  font-variant-numeric: tabular-nums;
`
